<template>
  <b-modal v-model="show" centered title="Neues Erlöskonto"
  >
    <b-row class="justify-content-md-center">
      <b-col>
        <label for="name">Konto</label>
        <b-form-input id="name" type="text"
                      v-model="k_konto.konto"
                      class="mb-2 text-black"
                      maxlength="11"
                      @focusin="error = false"
                      :state="error ? false : null"
        ></b-form-input>
        <b-form-text style="text-align: right" v-if="!error">{{k_konto.konto.length}}/11</b-form-text>
        <b-form-text style="text-align: right; color: red !important;" v-else>Das Konto darf nicht leer sein.</b-form-text>
        <label for="name">Name</label>
        <b-form-input id="name" type="text"
                      v-model="k_konto.konto_txt"
                      class="mb-2 text-black"
                      maxlength="50"
        ></b-form-input>
        <b-form-text style="text-align: right">{{k_konto.konto_txt.length}}/50</b-form-text>
        <label for="name">Gruppe</label>
        <b-form-input id="name" type="text"
                      v-model="k_konto.konto_grp"
                      class="mb-2 text-black"
                      maxlength="50"
        ></b-form-input>
        <b-form-text style="text-align: right">{{k_konto.konto_grp.length}}/50</b-form-text>
        <label for="name">Art</label>
        <b-form-input id="name" type="text"
                      v-model="k_konto.konto_typ"
                      class="mb-2 text-black"
                      maxlength="1"
        ></b-form-input>
        <b-form-text style="text-align: right">{{k_konto.konto_typ.length}}/1</b-form-text>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" @click="onSave">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: "CreateKKontoDialog",
  data() {
    return {
      show: false,
      k_konto: {
        konto: '',
        konto_txt: '',
        konto_grp: '',
        konto_typ: '',
      },
      error: false,
    }
  },
  methods: {
    showModal() {
      this.k_konto = {
        konto: '',
        konto_txt: '',
        konto_grp: '',
        konto_typ: '',
      };
      this.error = false;
      this.show = true;
    },
    getReturnData() {
      return this.k_konto;
    },
    async onSave() {
      this.k_konto.konto = this.k_konto.konto.trim();
      this.k_konto.konto_txt = this.k_konto.konto_txt.trim();
      if (!this.k_konto.konto) {
        this.error = true;
        return;
      }
      let data = this.getReturnData();
      this.$emit('create-k-konto', data);
      this.show = false;
    },

    onCancel() {
      this.show = false;
    }
  }
}
</script>

<style scoped>
.text-black {
  color: black;
}
.vld-overlay.is-full-page {
  z-index: 1600;
  position: fixed;
}
</style>
